// extracted by mini-css-extract-plugin
module.exports = {"img":"CompanyAvatar_img__2H0NL"};